import {
  UPDATE_TITLE,
  UPDATE_RETURN_LINK
} from './types'

const initialState = {
  title: null,
  returnLinkKwargs: null
}

const getters = {
  vueTitle: state => state.title,
  vueReturnLinkKwargs: state => state.returnLinkKwargs
}

const actions = {
  update_title ({ commit }, title) {
    commit(UPDATE_TITLE, title)
  },
  update_return_kwargs ({ commit }, returnLinkKwargs) {
    commit(UPDATE_RETURN_LINK, returnLinkKwargs)
  }
}

const mutations = {
  [UPDATE_TITLE] (state, title) {
    state.title = title
  },
  [UPDATE_RETURN_LINK] (state, returnLinkKwargs) {
    state.returnLinkKwargs = returnLinkKwargs
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/routing.js